import axios from "axios";
import store from "../store/store";
import { logoutRequest } from "../redux/auth/logout/actions";

//const baseURL = "https://api.indiagethired.com/";
export const API_BASE = "https://api-test.xyntara.in/";
//export const API_BASE = "http://localhost:8080/";
export const CENTRAL_BASE_URL = "https://zoblik.com/sso/";

const baseURL = API_BASE;

const AxiosInstance = () => {
  let token = localStorage.getItem("_token");
  //let token = "6e86c40fc8b1e9cfff6f539fcc4ef517cc9f8b6f2b964cdcee6bbe35e6d71a48";

  const instance = axios.create({
    baseURL,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
    withCredentials: true,
  });

  // Response Interceptor to Handle 401 Errors (invalid/expired token → clear storage and redirect to login)
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        let user_data = null;
        try {
          user_data = JSON.parse(localStorage.getItem("user_data") || "null");
        } catch (_) {
          user_data = null;
        }

        // Delete central cookie
        try {
          const central_url = `${CENTRAL_BASE_URL}logout.php`;

          await fetch(central_url, {
            credentials: "include",
            method: "POST",
            headers: { "Content-Type": "application/json" },
          });
        } catch (_) {}

        store.dispatch(logoutRequest());

        localStorage.removeItem("user_data");
        localStorage.removeItem("_token");
        localStorage.removeItem("jobseeker_resume_redirected");

        // Admin routes (e.g. /admin/role/my_permissions) → admin login; otherwise use stored type
        const requestUrl = error.config?.url || "";
        const isAdminRoute = requestUrl.includes("/admin/");
        const type = user_data?.type?.toLowerCase();
        const loginPath =
          type === "admin" || isAdminRoute
            ? "/job/admin/login"
            : `/job/${type || "jobseeker"}/auth/login`;
        window.location.href = `${window.location.origin}${loginPath}`;
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

/** Public support endpoints — same baseURL and auth as the rest of the app */
export const supportApi = {
  getRoles: () => AxiosInstance().get("/support/roles"),

  getIssues: (roleId) =>
    AxiosInstance().get("/support/issues", { params: { role_id: roleId } }),

  getProblems: (issueId) =>
    AxiosInstance().get("/support/problems", { params: { issue_id: issueId } }),

  getSolutions: (problemId) =>
    AxiosInstance().get("/support/solutions", { params: { problem_id: problemId } }),

  getFallbackQuestions: () => AxiosInstance().get("/support/fallback-questions"),

  getTickets: (params) =>
    AxiosInstance().get("/support/tickets", {
      params: {
        ...(params.role_key && { role_key: params.role_key }),
        ...(params.email && { email: params.email }),
        ...(params.phone && { phone: params.phone }),
        ...(params.search && { search: params.search }),
        ...(params.status && { status: params.status }),
        ...(params.priority && { priority: params.priority }),
        ...(params.date_from && { date_from: params.date_from }),
        ...(params.date_to && { date_to: params.date_to }),
      },
    }),

  /** @param {FormData} formData — do not set Content-Type; axios sets multipart boundary */
  createTicket: (formData) => AxiosInstance().post("/support/create-ticket", formData),
};

export default AxiosInstance;
